import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import FillEmailIcon from "./icon-fill-email.svg";

export const Container = styled.div`
  font-size: 14px;
  font-family: ${fontRoboto};
`;

export const StyledFillEmailIcon = styled(FillEmailIcon)`
  margin-inline-end: 12px;
`;
